// Must be the first import — Sentry initialization (no-op when DSN missing)
import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress Recharts width(-1)/height(-1) console warning that fires before
// ResizeObserver measures parent. Charts still render correctly — purely cosmetic.
const _origWarn = console.warn;
console.warn = (...args) => {
  const msg = args?.[0];
  if (typeof msg === "string" && /^The width\(-?\d+\) and height\(-?\d+\)/.test(msg)) return;
  _origWarn.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
